import { render, staticRenderFns } from "./EditRepairTypeUser.vue?vue&type=template&id=af282108"
import script from "./EditRepairTypeUser.vue?vue&type=script&lang=js"
export * from "./EditRepairTypeUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports